<template>
	<div>
		<h1 class="page-header"><i class="fa fa-globe"></i> Rendszer beállítások <small></small></h1>
		<hr>
		<panel title="Globális beállítások">
			<Loading v-if="!settings"></Loading>
			<NoRecords v-else-if="settings.length == 0" main_icon="fa fa-globe" title="Nem találhatóak beállítások"></NoRecords>
			<div class="row" v-else>
				<div class="col-md-4" v-for="(setting,id) in filtered_settings" :key="id">
					<form @submit.prevent="updateSetting(setting)">
						<div class="form-group">
							<label class="form-label">{{setting.name}}</label>
							<div class="input-group" v-if="setting.input_type === 'checkbox'">
								<div class="form-check">
									<input type="checkbox" class="form-check-input" v-model="setting.value" :true-value="1" :false-value="0">
								</div>
								<button class="btn btn-success">
									<i class="fa fa-save"></i>
								</button>
							</div>
							<div class="input-group" v-else>
								<input :type="setting.input_type" class="form-control" v-model="setting.value">
								<button class="btn btn-success">
									<i class="fa fa-save"></i>
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</panel>
	</div>
</template>

<script>	
	import Setting from '../../apis/Setting';
	import Confirmation from '../../apis/Confirmation';
	export default {
		name:'Settings',
		data() {
			return {
				settings:null,
			}
		},
		computed:{
			filtered_settings(){
				if(this.settings){
					return this.settings.filter(s => !['apartment_is_member','apartment_not_member'].includes(s.label))
				}else{
					return [];
				}
			},
		},
		created() {
			Setting.index()
			.then(response => {
				this.settings = response.data;
			}).catch(() => {
				this.settings = []
			})
		},
		methods: {
			updateSetting(setting){
				Setting.update(setting.id,setting)
				.then(() => {
					Confirmation.swalSuccessMessage('Sikeres mentés');
					Setting.index()
					.then(response => {
						this.settings = response.data;
					})
				})
			}
		}
	};
</script>